(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  const preloadInitialCollectionImage = (image) =>
    new Promise((resolve) => {
      const preloader = new Image();

      preloader.onload = async () => {
        try {
          await preloader.decode();
        } catch (error) {
          resolve(true);
          return;
        }

        resolve(true);
      };

      preloader.onerror = () => resolve(false);

      if (image.sizes) preloader.sizes = image.sizes;
      if (image.srcset) preloader.srcset = image.srcset;
      preloader.src = image.src;
    });

  const revealInitialCollectionImage = async (image) => {
    try {
      await image.decode();
    } catch (error) {
      if (!image.naturalWidth) return;
    }

    image.classList.add('collection-product-image--ready');
  };

  const initializeCollectionImages = () => {
    const grid = document.querySelector('#product-grid.collection-product-grid--preloading');
    if (!grid) return;

    grid.querySelectorAll('.card__media .media > img:first-child').forEach((image, index) => {
      if (index < 8) {
        preloadInitialCollectionImage(image).then((isReady) => {
          if (isReady) image.classList.add('collection-product-image--ready');
        });
        return;
      }

      if (image.complete) {
        revealInitialCollectionImage(image);
        return;
      }

      image.addEventListener('load', () => revealInitialCollectionImage(image), { once: true });
    });
  };

  initializeCollectionImages();
  document.addEventListener('collection:product-grid-updated', initializeCollectionImages);

  if (!customElements.get('collection-load-more')) {
    class CollectionLoadMore extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.link = this.querySelector('[data-load-more-link]');
        if (!this.link) return;
        this.link.addEventListener('click', this.loadNextPage.bind(this));
      }

      preloadImage(image) {
        return new Promise((resolve) => {
          const preloader = new Image();
          const finish = async () => {
            try {
              await preloader.decode();
            } catch (error) {
              resolve();
              return;
            }
            resolve();
          };

          preloader.onload = finish;
          preloader.onerror = resolve;

          if (image.sizes) preloader.sizes = image.sizes;
          if (image.srcset) preloader.srcset = image.srcset;
          preloader.src = image.src;
        });
      }

      async loadNextPage(event) {
        if (this.getAttribute('aria-busy') === 'true') return;

        event.preventDefault();

        const destination = this.link.href;
        const label = this.querySelector('[data-load-more-label]');
        const shown = this.querySelector('[data-load-more-shown]');
        const total = this.querySelector('[data-load-more-total]');
        const status = this.querySelector('[data-load-more-status]');
        const defaultLabel = label.textContent;

        this.setAttribute('aria-busy', 'true');
        this.link.setAttribute('aria-disabled', 'true');
        label.textContent = this.dataset.loadingText;

        try {
          const requestUrl = new URL(destination);
          requestUrl.searchParams.set('section_id', this.dataset.sectionId);

          const response = await fetch(requestUrl.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });

          if (!response.ok) throw new Error(response.statusText);

          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incomingGrid = documentFragment.querySelector('#product-grid');
          const currentGrid = this.closest('#ProductGridContainer')?.querySelector('#product-grid');

          if (!incomingGrid || !currentGrid) throw new Error('Product grid unavailable');

          const incomingItems = Array.from(incomingGrid.children);
          const incomingImages = incomingItems.flatMap((item) =>
            Array.from(item.querySelectorAll('.card__media .media > img:first-child')),
          );

          incomingImages.forEach((image) => image.setAttribute('loading', 'eager'));

          await Promise.race([
            Promise.all(incomingImages.map((image) => this.preloadImage(image))),
            new Promise((resolve) => setTimeout(resolve, 6000)),
          ]);

          incomingImages.forEach((image) => image.classList.add('collection-product-image--ready'));

          incomingItems.forEach((item) => {
            item.classList.add('scroll-trigger--cancel');
            item
              .querySelectorAll('.scroll-trigger')
              .forEach((element) => element.classList.add('scroll-trigger--cancel'));
            currentGrid.appendChild(item);
          });

          const loadedCount = Number(shown.textContent) + incomingItems.length;
          shown.textContent = String(loadedCount);
          status.textContent = loadedCount + ' / ' + total.textContent;

          const nextLink = documentFragment.querySelector('collection-load-more [data-load-more-link]');

          if (nextLink) {
            const nextUrl = new URL(nextLink.href);
            nextUrl.searchParams.delete('section_id');
            this.link.href = nextUrl.toString();
            label.textContent = defaultLabel;
            this.link.removeAttribute('aria-disabled');
            this.setAttribute('aria-busy', 'false');
          } else {
            this.remove();
          }
        } catch (error) {
          window.location.assign(destination);
        }
      }
    }

    customElements.define('collection-load-more', CollectionLoadMore);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tortli-region-recommendation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tortli-region-recommendation')) {
    customElements.define('tortli-region-recommendation', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.hidden = true;
        this.target = this.querySelector('[data-target]');
        this.countries = this.dataset.countries.toUpperCase().split(/[\s,]+/).filter(code => /^[A-Z]{2}$/.test(code));
        let targetUrl;
        try { targetUrl = new URL(this.target.href); } catch { return; }
        if (location.hostname !== this.dataset.sourceHost || targetUrl.protocol !== 'https:' || targetUrl.origin === location.origin || !this.countries.length) return;
        this.preferenceKey = `tortli:store-suggestion:${location.hostname}:${targetUrl.origin}:${this.countries.join(',')}`;
        if (this.isDismissed()) return;
        const signal = this.controller.signal;
        this.addEventListener('click', event => {
          if (event.target.closest('[data-dismiss], [data-target]')) this.dismiss();
        }, { signal });
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape') { event.preventDefault(); this.dismiss(); }
        }, { signal });
        document.addEventListener('focusin', event => {
          if (this.hidden || this.contains(event.target)) return;
          const focused = event.target.getBoundingClientRect();
          const card = this.getBoundingClientRect();
          if (focused.right > card.left && focused.left < card.right && focused.bottom > card.top && focused.top < card.bottom) this.hidden = true;
        }, { signal });
        if (document.readyState === 'complete') this.detectCountry();
        else window.addEventListener('load', () => this.detectCountry(), { once: true, signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
      isDismissed() {
        for (const name of ['localStorage', 'sessionStorage']) {
          try { if (Number(window[name].getItem(this.preferenceKey)) > Date.now()) return true; } catch {}
        }
        return false;
      }
      dismiss() {
        const days = Math.min(30, Math.max(1, Number(this.dataset.dismissDays) || 14));
        for (const name of ['localStorage', 'sessionStorage']) {
          try { window[name].setItem(this.preferenceKey, String(Date.now() + days * 86400000)); break; } catch {}
        }
        const focused = this.contains(document.activeElement);
        this.hidden = true;
        if (focused && this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
      }
      async detectCountry() {
        const cacheKey = 'tortli:detected-country:v1';
        let country;
        try {
          const cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
          if (cached?.expires > Date.now() && /^[A-Z]{2}$/.test(cached.country)) country = cached.country;
        } catch {}
        if (!country) {
          const timeout = setTimeout(() => this.controller.abort(), 4000);
          try {
            const endpoint = new URL('browsing_context_suggestions.json', new URL(this.dataset.rootUrl, location.origin));
            if (endpoint.origin !== location.origin) return;
            endpoint.searchParams.set('country[enabled]', 'true');
            const response = await fetch(endpoint, { credentials: 'same-origin', signal: this.controller.signal });
            if (!response.ok) return;
            const data = await response.json();
            country = data.detected_values?.country?.handle;
            if (!/^[A-Z]{2}$/.test(country)) return;
            try { sessionStorage.setItem(cacheKey, JSON.stringify({ country, expires: Date.now() + 1800000 })); } catch {}
          } catch { return; } finally { clearTimeout(timeout); }
        }
        if (!this.isConnected || this.controller.signal.aborted || !this.countries.includes(country) || this.isDismissed()) return;
        if (document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) return;
        this.previousFocus = document.activeElement;
        this.hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tortli-school-countdown"] && !Shopify.designMode) return;
  try {
    
  function initializeSchoolCountdowns(root) {
    root.querySelectorAll('[data-school-countdown]:not([data-countdown-ready])').forEach(function (clock) {
      clock.setAttribute('data-countdown-ready', 'true');
      var target = new Date(clock.dataset.target).getTime();
      var expired = clock.parentElement.querySelector('[data-countdown-expired]');
      var timer;

      function renderCountdown() {
        var distance = target - Date.now();
        if (!Number.isFinite(target) || distance <= 0) {
          clock.hidden = true;
          if (expired) expired.hidden = false;
          if (timer) window.clearInterval(timer);
          return;
        }

        var days = Math.floor(distance / 86400000);
        var hours = Math.floor((distance % 86400000) / 3600000);
        var minutes = Math.floor((distance % 3600000) / 60000);
        var seconds = Math.floor((distance % 60000) / 1000);

        clock.querySelector('[data-days]').textContent = String(days).padStart(2, '0');
        clock.querySelector('[data-hours]').textContent = String(hours).padStart(2, '0');
        clock.querySelector('[data-minutes]').textContent = String(minutes).padStart(2, '0');
        clock.querySelector('[data-seconds]').textContent = String(seconds).padStart(2, '0');
      }

      renderCountdown();
      timer = window.setInterval(renderCountdown, 1000);
    });
  }

  initializeSchoolCountdowns(document);
  document.addEventListener('shopify:section:load', function (event) {
    initializeSchoolCountdowns(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
